let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

class IdexImage extends HTMLElement {
  constructor() {
    super();

    this.img = this.querySelector('[data-idex-image]');
    if (!this.img) return;

    this.active = false;
    this.timeout = null;
    this.movementPx = 0;

    this.viewportHeight =
      window.visualViewport?.height || window.innerHeight;

    this.setup();
    this.update();

    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

    window.addEventListener('resize', this.onResize.bind(this), { passive: true });
  }

  setup() {
    const movement = parseFloat(this.img.dataset.id) || 100;
    const rect = this.getBoundingClientRect();

    this.movementPx = rect.height * (movement / 100);

    this.img.style.height = `calc(100% + ${this.movementPx}px)`;
    this.img.style.top = '0';
    this.img.style.bottom = 'auto';
    this.img.style.willChange = 'transform';
    this.img.style.transform = 'translate3d(0,0,0)';
  }

  getTranslateY() {
    const rect = this.getBoundingClientRect();
    const angle =
      (this.getAttribute('angle') || this.img.dataset.angle || 'top') === 'bottom'
        ? 'bottom'
        : 'top';

    const multiplier = angle === 'top' ? -1 : 1;

    const progress =
      angle === 'top'
        ? (this.viewportHeight - rect.top) /
          (this.viewportHeight + rect.height)
        : rect.bottom / (this.viewportHeight + rect.height);

    const clamped = Math.min(Math.max(progress, 0), 1);
    return clamped * this.movementPx * multiplier;
  }

  update() {
    this.img.style.transform = `translate3d(0, ${this.getTranslateY()}px, 0)`;

    if (this.active) {
      requestAnimationFrame(this.update.bind(this));
    }
  }

  onScroll() {
    if (!this.active) {
      this.active = true;
      requestAnimationFrame(this.update.bind(this));
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.active = false;
    }, 24);
  }

  onResize() {
    this.viewportHeight =
      window.visualViewport?.height || window.innerHeight;
  }
}

customElements.define('idex-image', IdexImage);
